import { useInfiniteQuery } from "@tanstack/react-query";
import { adaptPublishedForms } from "src/adapters";
import cmsClient from "src/services/cmsClient";

const select = adaptPublishedForms;

const getNextPageParam = ({ next }: CMSPaginatedData<IObservationForm>) => {
	return next;
};

const fetchPublishedForms = async (nextPageUrl?: string, category?: string) => {
	const url = nextPageUrl || "/observations/forms/";

	const response = await cmsClient.get<CMSPaginatedData<IObservationForm>>(
		url,
		{
			params: {
				category_name: category
			}
		}
	);
	return response.data;
};

interface Options {
	enabled?: boolean;

	category?: string;
}

const usePublishedFormsQuery = (options: Options = { enabled: true }) => {
	const { enabled, category } = options;

	const query = useInfiniteQuery(
		["publishedForms", category],
		({ pageParam }) => fetchPublishedForms(pageParam, category),
		{
			enabled,
			getNextPageParam,
			select
		}
	);

	return query;
};

export default usePublishedFormsQuery;
